var filter = function(ProductImageSrc) {
  return function(input, productLine, width, height) {
    return {
      'background-image': 'url(' + ProductImageSrc.imgSrc(productLine, width, height) + ')'
    };
  };
};

filter.$inject = ['ProductImageSrc'];

tiz.filter('product_image_style_filter', filter);
